import { Pipe, PipeTransform } from '@angular/core';
import { MESSAGES } from 'src/app/core/constants/messages';

@Pipe({
  name: 'requiredError',
})
export class RequiredErrorPipe implements PipeTransform {
  transform(field?: unknown): string {
    return field && field !== ''
      ? `The ${field} field is required`
      : MESSAGES.ERROR.REQUIRED.GENERIC;
  }
}
